import { ProfileAvatar } from './profile-avatar'
import { MoreSvgIcon } from '../../util/images'
import { forwardRef } from 'react'

export const ProfileSettingsTrigger = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      className="d-flex align-items-center border border-primary rounded-md mr-[10px] lg:mr-0 p-1 lg:pr-2 w-[38px] lg:w-[54px] h-[34px] hover:bg-primary transition-colors duration-200 [&[data-state=open]]:bg-primary"
      data-testid="profile-settings-trigger"
    >
      <ProfileAvatar size="small" className="lg:mr-2" />
      <MoreSvgIcon data-testid="more-icon" className="hidden lg:block" />
    </div>
  )
})

ProfileSettingsTrigger.displayName = 'ProfileSettingsTrigger'
